import { useState } from 'react';

import SvgIcon from '../../SvgIcon/SvgIcon';
import ProductRegistrationPopup from '../../Catalog/items/ProductRegistrationPopup';

interface Props {
  /** Se llama al cerrar el popup para refrescar la lista de productos. */
  onReload?: () => void | Promise<void>;
  message?: string;
}

/**
 * Botón "＋ Nuevo" que abre el mismo `ProductRegistrationPopup` del catálogo.
 * Al cerrarse, recarga la lista de productos (sin autoselección — mismo patrón
 * que `QuickAddSupplier`).
 */
const QuickAddProduct: React.FC<Props> = ({
  onReload,
  message = '¿No encuentras el producto? Puedes registrar uno nuevo.',
}) => {
  const [popupOpen, setPopupOpen] = useState(false);

  const closePopup = () => {
    setPopupOpen(false);
    void onReload?.();
  };

  return (
    <div className="mt-1 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-gray-600 dark:text-gray-300 text-xs">{message}</p>

      <div className="flex items-center gap-2">
        <button
          onClick={onReload}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-[#3CA745] px-2 py-1 text-xs font-medium text-white transition hover:bg-opacity-90"
        >
          <SvgIcon name="refresh" className="h-3 w-3" />
          Recargar
        </button>

        <button
          onClick={() => setPopupOpen(true)}
          type="button"
          className="inline-flex items-center gap-1 rounded bg-primary px-2 py-1 text-xs font-medium text-white transition hover:bg-opacity-90"
        >
          <SvgIcon name="plus" className="h-3 w-3" />
          Nuevo
        </button>
      </div>

      <ProductRegistrationPopup popupOpen={popupOpen} onClose={closePopup} />
    </div>
  );
};

export default QuickAddProduct;
